import classNames from 'classnames'

import { Loader } from 'core-components/library/loader'

import styles from './RemoveButton.module.scss'

interface IRemoveButton {
  onClick: () => void
  disabled?: boolean
  isRemoving?: boolean
  color?: 'danger' | 'gray'
  /**
   * Remove button test ID. This property is used for automated tests.
   */
  __testId?: string
}

export const RemoveButton = ({
  onClick,
  disabled,
  isRemoving,
  color = 'danger',
  __testId,
}: IRemoveButton) => {
  if (isRemoving) {
    return (
      <div className={styles.loader}>
        <Loader dimension={{ width: 10, height: 10 }} />
      </div>
    )
  }

  return (
    <div
      onMouseDown={async (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!disabled) {
          onClick()
        }
      }}
      className={classNames(styles.root, styles[`color-${color}`])}
      data-testid={__testId || 'removeBtn'}
    >
      <i className={'kbase kbase-sm kbase-close-circle'} />
    </div>
  )
}
